.helperText__disabled {
  opacity: var(--opacity-disabled-regular);
}
